module.exports = __webpack_public_path__ + "static/Montserrat-Light-kern-latin-fdbf29708e1b0400a124785a8ccadc1f.woff2";